import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-payment-failure',
  templateUrl: './payment-failure.component.html',
  styleUrls: ['./payment-failure.component.scss']
})
export class PaymentFailureComponent implements OnInit {

  constructor(
    private router : Router,
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.router.navigate(['/horizontal/food-menu']);
    }, 3000);
  }

}
